import { MonitorSmartphone, Briefcase, Cpu } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
const services = [{
  title: "Managed IT (The Partnership)",
  description: "We don't just fix computers; we join your team. Our proactive monitoring and helpdesk support ensure your business runs smoothly 24/7.",
  icon: MonitorSmartphone
}, {
  title: "Cybersecurity (The Shield)",
  description: "Protecting your local business from global threats. We implement enterprise-grade security protocols to keep your data safe and compliant.",
  icon: Briefcase
}, {
  title: "Infrastructure (The Foundation)",
  description: "From cable pulling to network rack organization, we build the physical backbone that powers your digital operations with precision.",
  icon: Cpu
}];
export default function SpecializedAiSolutions() {
  return <section data-section-id="223582" id="how-we-power-your-growth" className="bg-background text-foreground py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-16 text-center">
          <h2 className="font-default text-secondary text-3xl font-bold tracking-tight md:text-4xl">
            How We Power Your Growth
          </h2>
          <p className="text-muted-foreground font-default mx-auto mt-4 max-w-2xl text-lg">
            Passionate IT experts dedicated to supporting local businesses in Rapid City with reliable, human-centric technology solutions.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <Card key={i} data-index={i} className="border-border bg-card group rounded-2xl shadow-sm transition-all duration-300 hover:-translate-y-2 hover:border-primary/50 hover:shadow-xl">
                <CardHeader className="pb-4">
                  <div className="text-secondary mb-4 relative">
                    <Icon className="size-8 stroke-[2]" />
                    <div className="absolute -top-1 -right-1 size-2 rounded-full bg-primary" />
                  </div>
                  <CardTitle className="font-default text-secondary text-xl font-bold">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-muted-foreground font-default text-base leading-relaxed mb-6">
                    {service.description}
                  </CardDescription>
                  <div className="flex items-center gap-2 text-primary font-semibold text-sm group-hover:translate-x-1 transition-transform duration-200 cursor-pointer">
                    Learn More
                    <span className="text-lg">→</span>
                  </div>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}